import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f0a20a9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = { class: "container has-text-centered" }
const _hoisted_5 = { class: "card login-card has-text-left" }
const _hoisted_6 = { class: "tabs" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "message is-danger" }
const _hoisted_9 = { class: "message-header" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Error", -1))
const _hoisted_11 = { class: "message-body" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "message is-success" }
const _hoisted_14 = { class: "message-header" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Success!", -1))
const _hoisted_16 = { class: "message-body" }
const _hoisted_17 = { key: 2 }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Username ")
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Password ")
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = ["href"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fab fa-google" }, null, -1))
const _hoisted_26 = /*#__PURE__*/_createTextVNode("    Sign in with Google")
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = { key: 3 }
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Email ")
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Username ")
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" Password ")
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" Repeat Password ")
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", {
              class: _normalizeClass({ 'is-active': _ctx.type == 'login' })
            }, [
              _createElementVNode("a", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.tab_login && _ctx.tab_login(...args)))
              }, "Login")
            ], 2),
            _createElementVNode("li", {
              class: _normalizeClass({ 'is-active': _ctx.type == 'new' })
            }, [
              _createElementVNode("a", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.tab_create_account && _ctx.tab_create_account(...args)))
              }, "Create Account")
            ], 2)
          ])
        ]),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("article", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("button", {
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clearStatusMessage && _ctx.clearStatusMessage(...args))),
                    class: "delete",
                    "aria-label": "delete"
                  })
                ]),
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.error), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.success)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("article", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("button", {
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clearStatusMessage && _ctx.clearStatusMessage(...args))),
                    class: "delete",
                    "aria-label": "delete"
                  })
                ]),
                _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.success), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.type == 'login')
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _hoisted_18,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.username) = $event)),
                class: "input",
                type: "text",
                placeholder: "username"
              }, null, 512), [
                [_vModelText, _ctx.username]
              ]),
              _hoisted_19,
              _hoisted_20,
              _hoisted_21,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.password) = $event)),
                class: "input",
                type: "password",
                placeholder: "password"
              }, null, 512), [
                [_vModelText, _ctx.password]
              ]),
              _hoisted_22,
              _hoisted_23,
              _createElementVNode("a", {
                class: "button google",
                href: _ctx.api_path + '/auth/google'
              }, _hoisted_27, 8, _hoisted_24),
              _createElementVNode("div", {
                class: _normalizeClass([{ 'is-loading': _ctx.loading }, "button"]),
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args))),
                style: {"float":"right"}
              }, " Login ", 2)
            ]))
          : _createCommentVNode("", true),
        (_ctx.type == 'new')
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _hoisted_29,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.email) = $event)),
                class: "input",
                type: "text",
                placeholder: "email"
              }, null, 512), [
                [_vModelText, _ctx.email]
              ]),
              _hoisted_30,
              _hoisted_31,
              _hoisted_32,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.username) = $event)),
                class: "input",
                type: "text",
                placeholder: "username"
              }, null, 512), [
                [_vModelText, _ctx.username]
              ]),
              _hoisted_33,
              _hoisted_34,
              _hoisted_35,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.password) = $event)),
                class: "input",
                type: "password",
                placeholder: "password"
              }, null, 512), [
                [_vModelText, _ctx.password]
              ]),
              _hoisted_36,
              _hoisted_37,
              _hoisted_38,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.verify_password) = $event)),
                class: "input",
                type: "password",
                placeholder: "repeat password"
              }, null, 512), [
                [_vModelText, _ctx.verify_password]
              ]),
              _hoisted_39,
              _hoisted_40,
              _createElementVNode("div", {
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.createAccount && _ctx.createAccount(...args))),
                class: _normalizeClass([{ 'is-loading': _ctx.loading }, "button"]),
                style: {"float":"right"}
              }, "Create Account", 2)
            ]))
          : _createCommentVNode("", true),
        _hoisted_41,
        _hoisted_42
      ])
    ]),
    _hoisted_43,
    _hoisted_44
  ]))
}